<template>
  <v-app class="container">
    <router-view />
  </v-app>
</template>
